module.exports = "<div *ngFor=\"let alert of alerts\" class=\"{{ cssClass(alert) }} alert-dismissable\">\n     {{alert.message}}\n     <a class=\"close\" (click)=\"removeAlert(alert)\">&times;</a>\n</div>"


//////////////////
// WEBPACK FOOTER
// /var/www/html/foodbot_stage/web/src/app/_directives/alert.component.html
// module id = ../../../../../src/app/_directives/alert.component.html
// module chunks = main